/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DraftTag/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'



/** @type {import('Simple/types.js').View} */
export default function DraftTag({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Header/DraftTag"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 cursor="pointer"
 backgroundColor={dtColorsNeutral200}
 borderColor={dtColorsNeutral200}
 color={dtColorsNeutral900}
 alignSelf="auto"
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2InfoFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 fill2={dtColorsNeutral900}
 marginLeft={0}
 marginRight={dtSpaceXxs}
 width={16}
 height={16}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Draft"
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}